 <template>
  <v-row no-gutters class="hide-overflow flex-nowrap" style="height: 100%">
    <v-col>
      <v-row
        v-if="selectedPosition"
        no-gutters
        class="hide-overflow flex-nowrap"
        style="height: 100%"
      >
        <v-col cols="12" md="6" class="auto-overflow">
          <div
            style="overflow-y: auto; overflow-x: hidden; box-sizing: border-box; hidden; position: relative;"
          >
            <v-row class="ma-0">
              <v-col style="padding: 2rem">
                <v-card v-if="isPendingApproval" class="mb-8">
                  <v-card-title><h3 class="ma-0">Review job submission</h3></v-card-title>
                  <v-card-text
                    >This is a user submitted job posting. Please review the job post
                    details and accept or decline it. This will send a confirmation email to the email of the contact person.</v-card-text
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="acceptJob()"
                      >Accept job</v-btn
                    >
                    <v-btn color="error" text @click="declineDialog = true"
                      >Decline</v-btn
                    >
                  </v-card-actions>
                </v-card>

                <v-dialog v-model="declineDialog" max-width="360">
                  <v-card>
                    <v-card-title class="headline">
                      Select reason to decline
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-checkbox
                          v-for="reason in reasonsToHide"
                          :label="reason.description"
                          :value="reason.id"
                          :key="reason.id"
                          v-model="selectedReasons"
                          hide-details
                        ></v-checkbox>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn text @click="declineDialog = false">
                        Cancel
                      </v-btn>

                      <v-btn color="error" text @click="declineJob()">
                        Confirm
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-dialog v-model="deleteDialog" max-width="360">
                  <v-card>
                    <v-card-title class="headline">
                      Confirm deletion
                    </v-card-title>

                    <v-card-text>
                      Are you sure you want to delete this job?
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn text @click="deleteDialog = false">
                        Cancel
                      </v-btn>

                      <v-btn color="error" text @click="deleteJob()">
                        Delete
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                
                <v-alert
                  v-if="selectedPosition.status 
                        && Object.keys(selectedPosition.status.reportedBecause).length > 0"
                  type="error"
                  dense
                >
                  <label style="font-weight:bold">Job reported</label>
                  Reason(s): <span> {{ Object.keys(selectedPosition.status.reportedBecause).join(', ') }} </span>
                </v-alert>

                <div class="mb-6">
                  <div class="text-caption">Source</div>
                  <v-chip label small>{{selectedPosition.source.apiId}}</v-chip>
                </div>

                <v-text-field
                  v-model="title"
                  label="Job title"
                  placeholder="Enter job title"
                  outlined
                ></v-text-field>
                <v-select
                  v-model="selectedReasons"
                  :items="reasonsToHide"
                  label="Reasons to hide"
                  item-text="description"
                  item-value="id"
                  multiple
                  chips
                  outlined
                  dense
                  small-chips
                  :menu-props="{ offsetY: true }"
                ></v-select>
                <v-select
                  v-model="categories"
                  :items="categoryItems"
                  label="Categories"
                  multiple
                  chips
                  outlined
                  dense
                  small-chips
                  item-text="name"
                  item-value="id"
                  :menu-props="{ offsetY: true }"
                ></v-select>
                <v-combobox
                  v-model="tags"
                  :items="tagItems"
                  label="Tags"
                  multiple
                  chips
                  outlined
                  dense
                  small-chips
                ></v-combobox>

                <h3>Employer details</h3>

                <v-combobox
                  required
                  v-model="selectedEmployer"
                  :items="getEmployers"
                  label="Employer name"
                  placeholder="Select existing or create a new organisation"
                  outlined
                  item-text="name"
                  @change="employerSelected()"
                ></v-combobox>
                
                <v-text-field
                  v-model="selectedPosition.employer.externalUrl"
                  label="Link to website"
                  placeholder="https://"
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="selectedPosition.employer.careersUrl"
                  label="Link to careers page"
                  placeholder="https://"
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="selectedPosition.employer.imageUrl"
                  label="Logo URL"
                  placeholder="https://"
                  outlined
                ></v-text-field>

                <h3>Job details</h3>

                <v-text-field
                  v-model="selectedPosition.source.contactEmail"
                  label="Contact email"
                  outlined
                ></v-text-field>

                <v-text-field
                  v-model="city"
                  label="City"
                  placeholder="Enter city or cities"
                  outlined
                  dense
                ></v-text-field>

                <v-select
                  v-model="area"
                  :items="areaItems"
                  label="Region"
                  outlined
                  dense
                  :menu-props="{ offsetY: true }"
                ></v-select>
                
                <!-- <v-select
                  v-model="campaigns"
                  :items="campaignItems"
                  label="Campaigns"
                  multiple
                  chips
                  outlined
                  dense
                  item-text="title"
                  item-value="id"
                ></v-select> -->
                <v-menu
                  v-model="publishMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="selectedPosition.schedule.publish"
                      label="Publish job posting"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    required
                    v-model="selectedPosition.schedule.publish"
                    @input="publishMenu = false"
                  ></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="expiresMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="selectedPosition.schedule.expire"
                      label="Job posting expires on"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    required
                    v-model="selectedPosition.schedule.expire"
                    @input="expiresMenu = false"
                  ></v-date-picker>
                </v-menu>

                <div v-if="campaigns.length > 0" class="mb-6">
                  <label class="mb-2">Campaigns</label>
                  <v-chip
                    v-for="campaign in campaigns"
                    :key="campaign.id"
                    class="mb-2 mr-2"
                  >
                    {{ campaign.title }}
                  </v-chip>
                </div>

                <v-divider class="mb-4"></v-divider>

                <div v-if="isPendingApproval">
                  <h3>Review job</h3>
                  <v-btn
                    width="100%"
                    class="primary"
                    large
                    @click="acceptJob()"
                    >Accept job</v-btn
                  >
                  <v-btn
                    color="error"
                    outlined
                    width="100%"
                    class="mt-4"
                    large
                    @click="declineJob()"
                    >Decline job</v-btn
                  >
                </div>

                <div v-if="!isPendingApproval">
                  <v-btn
                    :loading="isSubmitting"
                    width="100%"
                    class="primary"
                    large
                    @click="saveJob()"
                    >Save</v-btn
                  >
                  <v-btn
                    color="error"
                    outlined
                    width="100%"
                    class="mt-4"
                    large
                    @click="deleteDialog = true"
                    >Delete</v-btn
                  >
                </div>

                <v-divider style="margin: 2rem 0 0"></v-divider>
              </v-col>
            </v-row>
            <div
              style="
                opacity: 0.7;
                padding: 0 1rem;
                box-sizing: border-box;
                font-size: 0.9rem;
                display: none;
              "
            >
              <v-row dense>
                <v-col><strong>Title:</strong></v-col>
                <v-col>{{ selectedPosition.title }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>Original categories:</strong></v-col>
                <v-col v-if="oldCategories">{{
                  oldCategories.length >= 1
                    ? oldCategories.join(", ")
                    : "No categories set"
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>Original tags:</strong></v-col>
                <v-col v-if="oldTags">{{
                  oldTags.length >= 1 ? oldTags.join(", ") : "No tags set"
                }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>Organization:</strong></v-col>
                <v-col>{{ selectedPosition.organization }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>Data origin:</strong></v-col>
                <v-col>{{ selectedPosition.dataOrigin }}</v-col>
              </v-row>
              <v-row dense>
                <v-col style="white-space: pre-wrap"
                  ><strong>Description:</strong></v-col
                >
                <v-col>{{ selectedPosition.content }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>First seen:</strong></v-col>
                <v-col>{{ selectedPosition.firstSeen }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>Last seen:</strong></v-col>
                <v-col>{{ selectedPosition.lastSeen }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>ID:</strong></v-col>
                <v-col>{{ selectedPosition.id }}</v-col>
              </v-row>
              <!-- <v-row dense>
                <v-col><strong>Language:</strong></v-col>
                <v-col>{{ selectedPosition.languages.join(", ") }}</v-col>
              </v-row> -->
              <v-row>
                <v-col><strong>Area:</strong></v-col>
                <v-col>{{ selectedPosition.location.area }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>City:</strong></v-col>
                <v-col>{{ selectedPosition.location.city }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>Country:</strong></v-col>
                <v-col>{{ selectedPosition.location.country }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>Original ID:</strong></v-col>
                <v-col>{{ selectedPosition.originalId }}</v-col>
              </v-row>
              <v-row dense>
                <v-col><strong>URL:</strong></v-col>
                <v-col class="position-url"
                  ><a :href="selectedPosition.url" target="_blank">{{
                    selectedPosition.url
                  }}</a></v-col
                >
              </v-row>
            </div>
          </div>
        </v-col>
        <v-col style="position: relative" cols="12" md="6">
          <iframe
            v-if="selectedPosition"
            :src="selectedPosition.externalUrl"
            style="
              width: 100%;
              height: 100%;
              border: 4px solid rgba(0, 0, 0, 0.2);
              box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);
              border-radius: 10px;
            "
          >
          </iframe>
          <div
            style="
              box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
              font-size: 0.8rem;
              position: absolute;
              top: 0;
              right: 0;
              display: flex;
              align-items: center;
              padding: 0.5rem 1rem;
              background: white;
              border-radius: 6px;
              cursor: pointer;
            "
            @click="openUrl(selectedPosition.externalUrl)"
          >
            URL PREVIEW
            <v-icon ripple class="position-open ml-2"> mdi-open-in-new </v-icon>
          </div>
        </v-col>
      </v-row>
      <v-row
        v-else
        align-content-md="center"
        align-md="center"
        style="height: 90vh; text-align: center"
      >
        <v-col> Select a position </v-col>
      </v-row>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        {{ text }}
        <v-btn text :color="color" @click="snackbar = false"> Close </v-btn>
      </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>
import jwt_decode from "jwt-decode";

export default {
  name: "PositionEdit",
  data() {
    return {
      categories: null,
      oldCategories: null,
      tags: null,
      oldTags: null,
      area: null,
      city: null,
      title: null,
      isSubmitting: false,
      snackbar: false,
      color: "success",
      text: "",
      timeout: 2000,

      selectedReasons: [],

      campaignItems: [],
      campaigns: [],

      publish: null,
      publishMenu: false,
      expires: null,
      expiresMenu: false,

      declineDialog: false,
      deleteDialog: false,

      reviewer: null
    };
  },
  mounted() {
    this.$store.dispatch("dispatchGetEmployers");

    if (!this.$store.state.reasonsToHide) {
      this.$store
        .dispatch("dispatchReasonsToHide")
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => {
          console.log(this.$store.state.reasonsToHide);
        });
    }
  },
  watch: {
    selectedPosition() {
      console.log("setting new things");
      console.log(this.selectedPosition);
      const categories = Object.values(
        this.selectedPosition.clustering.categories
      ).map((category) => category.id);
      this.categories = categories;
      this.oldCategories = categories;

      const tags = Object.values(this.selectedPosition.clustering.tags).map(
        (tag) => tag.id
      );
      this.tags = tags;
      this.oldTags = tags;

      this.area = this.selectedPosition.location.area;
      this.city = this.selectedPosition.location.city;
      this.title = this.selectedPosition.title;
      this.selectedReasons = Object.keys(
        this.selectedPosition.status.hiddenBecause
      );

      this.$store.dispatch("dispatchGetCampaignsWithJobs").then((campaigns) => {
        this.campaignItems = campaigns;
        this.campaigns = campaigns.filter((c) => {
          return (
            c.jobs.findIndex((job) => job.id == this.selectedPosition.id) > -1
          );
        });
      });
    },
  },
  computed: {
    /* selectedReasons: {
      get(){
        return Object.entries(this.hidden).filter((item) => item[1]).map((item) => item[0]);
        
      },
      set(reasons){
        Object.keys(this.hidden).forEach((key) => {
          if(reasons.findIndex(reason => reason == key) > -1){ this.hidden[key] = true; }
          else{ this.hidden[key] = false; }
        });
      }
    }, */
    selectedPosition() {
      return this.$store.state.selectedPosition;
    },
    categoryItems() {
      // console.log(this.$store.state.categories);
      return this.$store.state.categoriesWithDetails;
    },
    tagItems() {
      return this.$store.state.tags;
    },
    areaItems() {
      const areas = this.$store.state.mapData.map((area) => area.name);
      return areas;
    },
    /* campaignItems(){
      return this.$store.state.campaigns;
    }, */
    reasonsToHide() {
      return this.$store.state.reasonsToHide;
    },
    isPendingApproval() {
      return (
        this.selectedPosition.status.reviewStatus != "human" &&
        this.selectedPosition.status.hiddenBecause.userSubmitted
      );
    },
    getEmployers() {
      return this.$store.state.employers.employers;
    },
    selectedEmployer: {
      get: function () {
        return this.selectedPosition.employer;
      },
      set: function (value) {
        if(typeof(value) == "object"){
          // Existing employer
          this.selectedPosition.employer = value;
          delete this.selectedPosition.employer.id;
        }
        else{
          // New employer
          this.selectedPosition.employer.name = value;
          this.selectedPosition.employer.source = "jobsinfinland.fi-v1.0"
        }
      }
    }
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
    async getJobsAndUpdate() {
      await this.$store.dispatch('dispatchGetJobsAdmin');
      const terms = this.$store.state.searchTerms;
      this.$store.dispatch('commitSearchResults', terms);
    },
    saveJob(saveAction = "modify") {
      this.isSubmitting = true;

      const newCategories = [];
      if (this.categories) {
        this.categories.forEach((category) =>
          newCategories.push(
            this.categoryItems.find((cat) => cat.id == category)
          )
        );
      }
      const newTags = [];
      if (this.tags) {
        this.tags.forEach((tag) => newTags.push({ id: tag, confidence: 1 }));
      }

      console.log(this.selectedReasons);

      this.selectedPosition.status.hiddenBecause = {};
      this.selectedReasons.forEach((reason) => {
        this.selectedPosition.status.hiddenBecause[reason] = true;
      });

      delete this.selectedPosition.match;
      delete this.selectedPosition.sortKey;

      const reviewedJob = {
        ...this.selectedPosition,
        title: this.title,
        // review: null,
        location: {
          ...this.selectedPosition.location,
          area: this.area,
          city: this.city,
        },
        clustering: {
          ...this.selectedPosition.clustering,
          categories: newCategories,
          tags: newTags,
        },
        schedule: {
          publish: new Date(
            this.selectedPosition.schedule.publish
          ).toISOString(),
          expire: new Date(this.selectedPosition.schedule.expire).toISOString(),
        },
      };
      console.log(reviewedJob);

      this.$store
        .dispatch("dispatchPutAdminJob", {
          jobId: reviewedJob.id,
          jobData: reviewedJob,
          reviewerData: this.reviewer
        })
        .then((response) => console.log(response))
        .catch((error) => {
          if (error.response.status === 401) {
            this.text = "🤖 Seems you are not logged in any more - login again";
            this.color = "alert";
            this.snackbar = true;
          } else if (error.response.status === 400) {
            this.text =
              "🤖 Oh no! Bad input parameter, please check input fields";
            this.color = "alert";
            this.snackbar = true;
          }
          console.log(error);
          this.isSubmitting = false;
        })
        .finally(() => {
          this.text = "🤖 Position data updated. Thank you.";
          this.color = "success";
          this.snackbar = true;
          this.isSubmitting = false;
          this.getJobsAndUpdate();

          // Send review notifications
          switch(saveAction){
            case "acceptJob":
              this.$store
                .dispatch("dispatchPostAdminAcceptJob", { jobData: reviewedJob, reviewerData: this.reviewer })
                .then((response) => console.log(response));
              break;
            case "declineJob":
              this.$store
                .dispatch("dispatchPostAdminDeclineJob", { jobData: reviewedJob, reviewerData: this.reviewer })
                .then((response) => console.log(response));
              break;
          }
        });

      /* this.campaigns.forEach((campaignId) => {
        let campaign = this.campaignItems.find((c) => c.id == campaignId);
        console.log(campaign);
        let jobs = campaign.jobs.length > 0 ? campaign.jobs.map((job) => { return job.id }) : [];
        jobs.push(this.selectedPosition.id);
        console.log(jobs);
        this.$store.dispatch("dispatchPutAdminCampaignJobs", { campaignId: campaign.id, jobIds: jobs });
      }); */
    },
    acceptJob(accept = true) {

      // Get user details and post with review
      let decodeToken = jwt_decode(this.$store.state.JWT);
      let userId = decodeToken.sub;
      this.$store.dispatch("dispatchGetUser", { userId }).then((user) => {
        this.reviewer = user;

        if(accept){
          // Job accepted
          this.selectedPosition.status.reviewStatus = "human";
          this.selectedPosition.status.hiddenBecause = {};
          this.selectedReasons = [];

          this.saveJob("acceptJob");
        } else {
          // Job declined
          this.declineDialog = false;
          this.selectedPosition.status.reviewStatus = "human";

          this.saveJob("declineJob");
        }
        
      });
    },
    declineJob() {
      this.acceptJob(false);
    },
    deleteJob() {
      this.deleteDialog = false;
      this.selectedPosition.status.reviewStatus = "human";
      this.selectedPosition.status.hiddenBecause = { deleted: true }
      this.selectedReasons = [ "deleted" ];

      this.saveJob();
    },
  },
};
</script>
<style scoped>
.position-url {
  overflow: hidden;
}
</style>